<template>
  <div class="myDesign">
    <div class="myDesign_wrap">
      <div
        class="design__nav"
        v-show="
          $route.name === 'bannerDesignList' ||
          $route.name === 'coverDesigns' ||
          $route.name === 'pageDesigns' ||
          $route.name === 'posterDesigns'
        "
      >
        <router-link to="/banner/list" active-class="select"
          >banner</router-link
        >
        <router-link to="/cover/list" active-class="select">封面</router-link>
        <router-link to="/aipage/list" active-class="select"
          >专题页</router-link
        >
        <router-link to="/poster/list" active-class="select">海报</router-link>
      </div>
      <transition name="fade">
        <router-view></router-view>
      </transition>
    </div>
  </div>
</template>
<script>
export default {
  name: "MyDesign",
  data() {
    return {};
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/styles/common.scss";
.myDesign {
  padding-top: 1px;
  height: 100%;
  overflow-y: auto;
  @include scroller;
  .myDesign_wrap {
    height: auto;
  }
  .design__nav {
    margin: 26px auto 6px;
    display: flex;
    justify-content: center;
    a {
      display: inline-block;
      width: 88px;
      height: 40px;
      margin: 0 10px;
      text-align: center;
      line-height: 40px;
      border-radius: 10px;
      font-size: 20px;
      font-weight: 500;
      color: #74899a;
      cursor: pointer;
    }
    .select {
      background: #ffffff;
      transition: all 0.2s;
      &:hover {
        box-shadow: 0px 0px 10px 2px rgba($color: #000000, $alpha: 0.06);
      }
    }
  }
}
.fade-enter-active,
.fade-leave-avtive {
  transition: opacity 0.2s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
